import styled from "styled-components";
import { FlexColumn } from "styles/layout";
import { Theme } from "theme";

export const HeaderContainer = styled(FlexColumn)`
  row-gap: 15px;
`;

export const DetailsContainer = styled.div`
  padding: ${Theme.bigPanelPadding};
`;

export const GroupName = styled.div`
  font-size: 16pt;
  font-weight: 500;
`;

export const GroupCode = styled.div`
  margin-left: auto;
  font-size: 13pt;
  padding-left: 10px;
  font-weight: 500;
  color: gray;
`;

export const OwnerName = styled.div`
  color: gray;
  font-size: 10.5pt;
`;

export const MemberCount = styled.div`
  color: gray;
  font-size: 10.5pt;
`;

export const TabsContainer = styled.div`
  border-top: ${Theme.panelContentBorder};
`;
